(function() {
    'use strict';
    
a3_cabin_reports.factory('CrewRouteFactory', CrewRouteFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name CrewRouteFactory
    * @description 
    * Get and Update Crew Routes 
    * @ngInject
    */ 
function CrewRouteFactory(GenericService, FlightFactory, GroundDutyFactory, $filter, AircaftPositionsFactory, CrewMealFactory, FlightDelaysFactory) {

		var objType ='crewRoute';
		var objCallback = CrewRoute;

		var service = {
            getCrewRoutesFromStorage : getCrewRoutesFromStorage,
            setCrewRoutesToStorage : setCrewRoutesToStorage,
            setCourseCompleted: setCourseCompleted,
            setCoursePending : setCoursePending, 
            
            updateCrewMealsInRoute:updateCrewMealsInRoute, 
            updateRouteLastRefreshDate: updateRouteLastRefreshDate, 
            getCrewRouteFromStorage: getCrewRouteFromStorage,
            getCrewRouteDuties : getCrewRouteDuties, 
            getCrewRouteInfoPanel :  getCrewRouteInfoPanel,   
            getCrewRouteFlights:getCrewRouteFlights,
            getSACrewMembersFromRoute:getSACrewMembersFromRoute,
            getFACrewMembersFromRoute:getFACrewMembersFromRoute,

            updateCrewRouteDuty: updateCrewRouteDuty,
            addCrewRouteDuty : addCrewRouteDuty,
            getManualFlightTrainingsFromStorage: getManualFlightTrainingsFromStorage,
            removeFlightTraining: removeFlightTraining,
            insertCrewRoutesWithPendingTrainings: insertCrewRoutesWithPendingTrainings
         };
        
        /**
        * Initialize the CrewRoute
        * @memberof CrewRouteFactory
        */
		function CrewRoute() {
            this.DutyDay = null; 
            this.DutyNo = null; 
            this.Route = null;
            this.DutyBegin = null;
            this.DutyEnd = null;
            this.CrewMeals = [];
            //new property: get the value from CrewAssessmentFactory
            this.LastRefreshed = null;
        }
      

        /**
         * Get Crew Routes
         * @memberof CrewRouteFactory
         * @returns {Array} CrewRoutes 
         */
		function getCrewRoutesFromStorage() {
			return GenericService.list(objType,objCallback);
		}
        
        /**
         * Save Crew Routes to storage
         * @memberof GroundDutyFactory
         * @param {Array} objList A list of Crew Routes
         */
		function setCrewRoutesToStorage(objList) {
			GenericService.saveAll(objList,objType);
        }

         /**
         * Get a specific Crew Route
         * @memberof CrewRouteFactory
         * @returns {object} CrewRoute
         */
        function getCrewRouteFromStorage(dutyNo, dutyDay){
            var crewRoutes = getCrewRoutesFromStorage();
			if (crewRoutes == null)
				return [];
			var arrayLength = crewRoutes.length;
			for (var i = 0; i < arrayLength; i++) {
				if (crewRoutes[i].DutyNo == dutyNo && crewRoutes[i].DutyDay == dutyDay) {
					return crewRoutes[i];
				}
            }
        }

        function setCourseCompleted(dutyNo, dutyDay, courseId, date){
            var crewRoutes = getCrewRoutesFromStorage();
            var crewRoute = crewRoutes.find(cr => cr.DutyNo == dutyNo && cr.DutyDay == dutyDay);
            if (!crewRoute || !Array.isArray(crewRoute.FlightIds) || !Array.isArray(crewRoute.Courses)) {
                return;
            }

            var flightIds = crewRoute.FlightIds;
            var flights = FlightFactory.getFlightsFromStorage().filter(x => flightIds.includes(x.FlightId));

            var crewRouteCourse = crewRoute.Courses.find(x => x.CourseId == courseId && new moment(x.Date).isSame(date));
            if(crewRouteCourse)  crewRouteCourse.Status = "Completed"; 
           
            flights.forEach(function(flight){
                var flightCourse = flight.Courses.find(x => x.CourseId == courseId && new moment(x.Date).isSame(date));
                if(flightCourse) {
                    flightCourse.Status = "Completed"; 
                    FlightFactory.updateFlight(flight);
                }
            });

            GenericService.saveAll(crewRoutes, objType, objCallback);
        }

        function setCoursePending(dutyNo, dutyDay, courseId, date){
            var crewRoutes = getCrewRoutesFromStorage();
            var crewRoute = crewRoutes.find(cr => cr.DutyNo == dutyNo && cr.DutyDay == dutyDay);
            if (!crewRoute || !Array.isArray(crewRoute.Courses)) {
                return;
            }
            var crewRouteCourse = crewRoute.Courses.find(x => x.CourseId == courseId && new moment(x.Date).isSame(date));
            if(crewRouteCourse)  crewRouteCourse.Status = "Pending"; 
            
            GenericService.saveAll(crewRoutes, objType, objCallback);
        }

        function getCrewRouteDuties(dutyNo, dutyDay, flightDate) {         
            var groundDuties = GroundDutyFactory.getGroundDutiesByDutyNo(dutyNo, dutyDay).filter(x => x.DutyDate == flightDate);
      
            if(groundDuties.length > 0){    //there are ground duties in this crew route
                angular.forEach(groundDuties, function(groundDuty)
                {
                    groundDuty.DutyType = "Ground";
                    groundDuty.Start = groundDuty.DutyBegin;
                    // groundDuty.Date = groundDuty.DutyDate;
                });
            }
    
            // var flights = FlightFactory.getFlightsByDutyNo(dutyNo, dutyDay).filter(x => x.DutyDate == flightDate);
           
            var flights = getCrewRouteFlights(dutyNo, dutyDay, flightDate);    
            if(flights.length > 0){    //there are flights in this crew route
                angular.forEach(flights, function(flight)
                {
                    flight.DutyType = "Flight";
                    flight.Start = flight.ScheduledDeparture;
                    flight.showNextAcPos = false;
                    flight.showPreviousAcPos = false;
                    flight.hasChangeAircraft = false;   
                    flight.isFirst = false;
                    flight.isLast = false;
                    flight.BTime = "";
                    flight.Delay = 0;
                    flight.ArrDelay = 0;
                    flight.crewMeals = "";
                    flight.aircaftPositions = null;
                    flight.flightDelays = null;
                });
            }
         
            flights = $filter('orderBy')(flights, 'Start');

            // check if aircraft change exists          

            flights.forEach(function(flight, index, array) {
                flight.isFirst = index == 0;
                flight.isLast = (index + 1 == array.length);

                if(flight.isFirst){
                    flight.showPreviousAcPos = true; 
                }
                if(flight.isLast){
                    flight.showNextAcPos = true;
                }
                if(!flight.isFirst && flights[index-1].AcTailNo != flight.AcTailNo)  {
                    flight.showPreviousAcPos = true;               
                } 
                if(!flight.isLast && flights[index+1].AcTailNo != flight.AcTailNo)  {
                    flight.showNextAcPos = true;  
                    flight.hasChangeAircraft = true;           
                } 

                
                var diffMin = Date.DifferenceInMinutes(flight.ScheduledDeparture, flight.ScheduledArrival);
                flight.BTime = Date.MinutesToStringSimple(diffMin);
            
                flight.Delay = moment(flight.ATD).diff(moment(flight.ScheduledDeparture), 'minutes') || "";
                flight.ArrDelay = moment(flight.ATA).diff(moment(flight.ScheduledArrival), 'minutes') || "";
                flight.aircaftPositions = AircaftPositionsFactory.getAircaftPositionsByFlightId(flight.FlightId);
                    
                if (flight.aircaftPositions) {   
                    // Previous Flight
                    flight.aircaftPositions.PreviousFlightDelay =  moment(flight.aircaftPositions.PreviousATD).diff(moment(flight.aircaftPositions.PreviousSTD), 'minutes') || "";
                    flight.aircaftPositions.PreviousFlightArrDelay = moment(flight.aircaftPositions.PreviousATA).diff(moment(flight.aircaftPositions.PreviousSTA), 'minutes') || "";

                    var diffPreviousFlightMin = Date.DifferenceInMinutes(flight.aircaftPositions.PreviousSTD, flight.aircaftPositions.PreviousSTA);
                    flight.aircaftPositions.PreviousFlightBTime = Date.MinutesToStringSimple(diffPreviousFlightMin);
                    flight.aircaftPositions.PreviousDelays = FlightDelaysFactory.getFlightDelaysByFlightId(flight.aircaftPositions.PreviousFlightId);

                    // Next Flight
                    flight.aircaftPositions.NextFlightDelay =  moment(flight.aircaftPositions.NextATD).diff(moment(flight.aircaftPositions.NextSTD), 'minutes') || "";
                    flight.aircaftPositions.NextFlightArrDelay = moment(flight.aircaftPositions.NextATA).diff(moment(flight.aircaftPositions.NextSTA), 'minutes') || "";

                    var diffNextFlightMin = Date.DifferenceInMinutes(flight.aircaftPositions.NextSTD, flight.aircaftPositions.NextSTA);
                    flight.aircaftPositions.NextFlightBTime = Date.MinutesToStringSimple(diffNextFlightMin);
                    flight.aircaftPositions.NextDelays = FlightDelaysFactory.getFlightDelaysByFlightId(flight.aircaftPositions.NextFlightId);
                    
                }
                flight.flightDelays = FlightDelaysFactory.getFlightDelaysByFlightId(flight.FlightId);
            });

            var crewRouteDuties = groundDuties.concat(flights);
            crewRouteDuties = $filter('orderBy')(crewRouteDuties, 'Start');

            return crewRouteDuties;
        }

        function getCrewRouteFlights(dutyNo, dutyDay, flightDate){
            var crewRoutes = getCrewRoutesFromStorage() || [];
            var crewRoute = crewRoutes.find(cr => cr.DutyNo == dutyNo && cr.DutyDay == dutyDay);

            if (!crewRoute || !Array.isArray(crewRoute.FlightIds)) {
                return [];
            }

            var flightIds = crewRoute.FlightIds;
            
            var flights = FlightFactory.getFlightsFromStorage().filter(x => flightIds.includes(x.FlightId) && x.FlightDate == flightDate);            

            return flights;
        }      

        function getCrewRouteAllFlights(dutyNo, dutyDay){
            var crewRoutes = getCrewRoutesFromStorage();
            var crewRoute = crewRoutes.find(cr => cr.DutyNo == dutyNo && cr.DutyDay == dutyDay);
            var flights = [];
            if(crewRoute && crewRoute.FlightIds && crewRoute.FlightIds.length > 0){
                flights = FlightFactory.getFlightsFromStorage().filter(x => crewRoute.FlightIds.includes(x.FlightId));  
            }
            return flights;
        }      

        function getSACrewMembersFromRoute(dutyNo, dutyDay, flightDate){
            var flights = getCrewRouteFlights(dutyNo, dutyDay, flightDate);
            var saMembers = [];
            flights.forEach(function (flight) {
                flight.crew.forEach(function (member){
                    if(member.position == 'SA' && !member.isDHC){
                        saMembers.push(member.aimsId);
                    }
                })
            });
            return saMembers;
        }

        function getFACrewMembersFromRoute(dutyNo, dutyDay, flightDate){
            var flights = getCrewRouteFlights(dutyNo, dutyDay, flightDate);
            var faMembers = [];
            flights.forEach(function (flight) {
                flight.crew.forEach(function (member){
                    if(member.position == 'FA' && !member.isDHC){
                        faMembers.push(member.aimsId);
                    }
                })
            });
            return faMembers;
        }

        function updateCrewRouteDuty(flightTraining){
            GenericService.updateFlight(flightTraining,objType, objCallback);
        }

        function addCrewRouteDuty(flightTraining){
            var crewRoutes = getCrewRoutesFromStorage();
            var crewRoute = crewRoutes.find(cr => cr.DutyNo == flightTraining.DutyNo && cr.DutyDay == flightTraining.DutyDay);
            if(crewRoute) {
                crewRoute.isManualEntry = true;
                crewRoute.hasPendingCourse = true; 
            }
            else{
                GenericService.add(flightTraining, objType, objCallback);
            }
        }

        function removeFlightTraining(dutyNo, dutyDay) {
            var crewRoutes = getCrewRoutesFromStorage();
            var crewRoute = crewRoutes.find(cr => cr.DutyNo == dutyNo && cr.DutyDay == dutyDay);
            if (!crewRoute) {
                return;
            }
            crewRoute.isManualEntry = false;
            crewRoute.hasPendingCourse = false; 
            GenericService.saveAll(crewRoutes,objType, objCallback);
        }

         /**Get manual flight trainings from storage*/
         function getManualFlightTrainingsFromStorage(){
            var crewRoutes = getCrewRoutesFromStorage();
            return crewRoutes.filter(x => x.isManualEntry);
        }
        
        function updateCrewMealsInRoute(dutyNo, dutyDay, newCrewMeals , newFlightIds){
            var crewRoutes = getCrewRoutesFromStorage();
            var crewRoute = crewRoutes.find(cr => cr.DutyNo == dutyNo && cr.DutyDay == dutyDay);

            if (!crewRoute || !Array.isArray(crewRoute.CrewMeals)) {
                return;
            }

            if (!Array.isArray(newFlightIds)) {
                newFlightIds = [];
            }

            if (!Array.isArray(newCrewMeals)) {
                newCrewMeals = [];
            }

            var crewMealsInRoute = crewRoute.CrewMeals.filter(f=> !newFlightIds.includes(f.FlightId));
            crewMealsInRoute = crewMealsInRoute.concat(newCrewMeals);
            crewRoute.CrewMeals = crewMealsInRoute;

            GenericService.saveAll(crewRoutes, objType, objCallback);
        }

        function insertCrewRoutesWithPendingTrainings(instructorPendingRoutes){
            if(instructorPendingRoutes.length > 0){
				var crewRoutes = getCrewRoutesFromStorage();
				var crewRoutesIdsLS = crewRoutes.map(x=>x.DutyNo);
				var routesToInsert = instructorPendingRoutes.filter(f=> !crewRoutesIdsLS.includes(f.DutyNo));
                if(routesToInsert.length > 0){
                    var updatedCrewRoutesList = crewRoutes.concat(routesToInsert);
                    GenericService.saveAll(updatedCrewRoutesList, objType, objCallback);
                }				
			}
              
        }

        /**
         * Update last Refresh date for a specific Crew Route
         * @memberof CrewRouteFactory
         */
        function updateRouteLastRefreshDate(dutyNo, dutyDay){
            var crewRoutes = getCrewRoutesFromStorage();
            var crewRoute = crewRoutes.find(cr => cr.DutyNo == dutyNo && cr.DutyDay == dutyDay);
            if (!crewRoute) {
                return;
            }
            crewRoute.LastRefreshed = moment().toDate().toUTC(); 

            GenericService.saveAll(crewRoutes, objType, objCallback);
        }
        /**
         * Get Crew Route Info panel information (inside Flight-page)
         * @memberof CrewRouteFactory
         * @returns {object} flights
         */
         function getCrewRouteInfoPanel(flight){
            var panelInfo = null;
            var crewRouteInfo = getCrewRouteFromStorage(flight.DutyNo, flight.DutyDay);
            var crewRouteDuties = getCrewRouteDuties(flight.DutyNo, flight.DutyDay, flight.FlightDate);
            var crewRouteFlightDuties = crewRouteDuties.filter(x => x.DutyType === "Flight");
      
            var hasAircraftPositions = crewRouteFlightDuties.length && 
                                       crewRouteFlightDuties.length > 0 &&  
                                       crewRouteFlightDuties[0].aircaftPositions != null;

            //update crewRouteDuties with the crewMeals
            var crewMealsPerFlightId = [];

            crewRouteInfo.CrewMeals.forEach(meals => {
                if (meals.CrewMealsCateringIds) { 
                    var crewMealsTitles = "";
    
                    for (var j = 0; j < Object.values(meals.CrewMealsCateringIds).length; j++) {
                        if (j != 0) {
                            crewMealsTitles += " & ";
                        } 
                        var crewMealDetails = CrewMealFactory.getCrewMealFromStorage( Object.values(meals.CrewMealsCateringIds)[j]);         
                        crewMealsTitles += crewMealDetails.ShortTitle;                                     
                    }  
                    crewMealsPerFlightId.push({ flightId: meals.FlightId, crewMeals: crewMealsTitles });                
                } 
            });
        
            if (crewMealsPerFlightId.length > 0) {
                crewRouteDuties.forEach(function(duty){
                    if (duty.FlightId == crewMealsPerFlightId[0].flightId) {
                        duty.crewMeals = crewMealsPerFlightId[0].crewMeals;
                    }  
                });
            }     
            
            var routeNeedRefresh = false; 
            if(!crewRouteInfo.LastRefreshed){
                routeNeedRefresh = true; 
            }

            return panelInfo = 
                    { 
                        crewRouteDuties : crewRouteDuties, 
                        routeNeedRefresh: routeNeedRefresh,
                        
                        hasAircraftPositions : hasAircraftPositions 
                    };
        }

        

		return service;
	}

})();